import api from './api'

// Never attach the API bearer token to an arbitrary URL from document metadata.
export const isWorkerDocumentFileUrl = (url: string) => /^\/api\/(?:workers\/me\/documents\/[0-9a-f-]{36}\/file|worker-profiles\/[0-9a-f-]{36}\/profile-photo)$/i.test(url)

export async function loadWorkerDocumentFile(url: string, ownerId: string, signal: AbortSignal): Promise<{ blob: Blob; filename: string }> {
  if (!isWorkerDocumentFileUrl(url)) throw new Error('Invalid worker document URL.')
  const response = await api.get<Blob>(url, {
    responseType: 'blob', signal, timeout: 30000,
    headers: { Accept: '*/*', 'x-account-owner-id': ownerId },
  })
  const disposition = String(response.headers['content-disposition'] || '')
  const filename = /filename="([^"]+)"/i.exec(disposition)?.[1] || 'worker-document'
  return { blob: response.data, filename }
}
